var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.is_need_test_password)?_c('PasswordPage'):(_vm.is_act_load)?_c('HomePage'):_c('div',{attrs:{"id":"app_loading"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }